import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import CodeBlueIcon from '@app/assets/icons/code-tag-blue.svg?react';
import CodeDarkBlueIcon from '@app/assets/icons/code-tag-dark-blue.svg?react';
import { Tooltip } from '@app/components/Tooltip/Tooltip';

interface VariableDropdownProps {
  onSelect: (variable: string) => void;
}

const variables = [
  'customer-first-name',
  'customer-last-name',
  'customer-full-name',
  'customer-email',
  'business-name',
  'business-address'
];

export const VariableDropdown = ({ onSelect }: VariableDropdownProps) => {
  const handleVariableSelect = (variable: string) => {
    onSelect(`{{${variable}}}`);
  };

  return (
    <Menu>
      <Tooltip content="Use variable" direction="up">
        <MenuButton
          type="button"
          className="flex items-center justify-center px-2 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <CodeBlueIcon className="w-4 h-4" />
        </MenuButton>
      </Tooltip>
      <MenuItems
        transition
        anchor="bottom"
        className="p-2 bg-white shadow-lg min-w-[220px] transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 rounded-lg border border-gray-200"
      >
        {variables.map((variable) => (
          <MenuItem key={variable}>
            <button
              onClick={() => handleVariableSelect(variable)}
              className="flex items-center gap-2 px-2 py-2 rounded-lg data-[focus]:bg-blue-50 text-xs w-full text-left"
            >
              <CodeDarkBlueIcon className="w-4 h-4" />
              <span className="font-mono">{variable}</span>
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};


